import { API_DATA_FORMAT, API_STATUS } from 'core-lib/constants/network';
import { EventCategoryName } from 'core-lib/types/Events';
import { ApiDataFormat } from 'core-lib/types/Network';
import { getDefaultAttributes, trackCustomGTMEvent, trackEvent } from 'core-lib/utils/events';
import React from 'react';
import { loginClicked } from '../constants';
import { BodyType, ResponseType, verifyOTP } from '../services/verifyOTP';
import { useAuth } from './useAuth';
import { getOriginalFromSigninWithBase } from '../../core-lib/utils/source';

interface ApiDataType extends ApiDataFormat {
  data: null | ResponseType;
}

export type OutputType = {
  apiCall: ApiDataType;
  init: (body: BodyType) => void;
  reset: () => void;
};

type ArgType = {
  handlePostLogin?: boolean;
};

export function useVerifyOTP({ handlePostLogin = true }: ArgType): OutputType {
  const [apiCall, setApiCall] = React.useState<ApiDataType>({
    ...API_DATA_FORMAT,
  });
  const { setAuthData } = useAuth();

  async function init(body: BodyType) {
    setApiCall({ ...apiCall, apiStatus: API_STATUS.in_progress });
    const { response, error } = await verifyOTP(body);
    if (response) {
      setApiCall({ ...apiCall, apiStatus: API_STATUS.success, data: response });
      if (handlePostLogin) {
        const reqData = {
          accessToken: response?.accessToken,
          refreshToken: response?.refreshToken,
          profile: response?.profile,
          userLocations: response?.userLocations,
        };
        setAuthData(reqData);
        // Track event
        trackEvent({
          name: loginClicked.name,
          defaultAttr: getDefaultAttributes(),
          attributes: {
            [loginClicked.attributes.mode]: 'phone',
            [loginClicked.attributes.mobileNumber]: body.phoneNumber,
            [loginClicked.attributes.category]: 'user onboarding',
          },
        });
        if (response?.isNewUser) {
          trackCustomGTMEvent({
            eventName: 'pm_signup',
            attributes: {
              category: EventCategoryName.Signin,
              phone_number: body.phoneNumber,
              redirected_from: getOriginalFromSigninWithBase(),
            },
          });
        } else {
          trackCustomGTMEvent({
            eventName: `pm_login${sessionStorage.getItem('source_initial_page_route').replace(/[\/-]/g, '_')}`,
            attributes: {
              category: EventCategoryName.Signin,
              phone_number: body.phoneNumber,
              redirected_from: getOriginalFromSigninWithBase(),
            },
          });
        }
      }
    }
    if (error) {
      setApiCall({
        ...apiCall,
        apiStatus: API_STATUS.failure,
        data: null,
        apiError: error,
      });
    }
  }

  return {
    init,
    apiCall,
    reset: () => setApiCall({ ...API_DATA_FORMAT }),
  };
}
